// Generated with util/create-component.js
import React from "react";

import { AlertProps } from "./Alert.types";
import { StyledAlert, StyledWarningAlert } from "./Alert.styles";

import Title from "../../Typography/Title/Title";
import { StyledTitleDividerLineOnly } from "../../Typography/Title/Title.styles";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

const Alert: React.FC<AlertProps> = ({ message, theme, title, variant, style }) => {
  switch (style) {
    default:
      return (
        <StyleSheetManager shouldForwardProp={isPropValid}>
          <StyledAlert data-testid="Alert" className={`gs-alert`} theme={theme} variant={variant}>
            {title && <Title bartype="bar" theme={theme} text={title} variant={variant} />}
            <div className="message">{message}</div>
          </StyledAlert>
        </StyleSheetManager>
      );
    case "warning":
      return (
        <StyleSheetManager shouldForwardProp={isPropValid}>
          <StyledWarningAlert data-testid="Alert" className={`gs-alert`} theme={theme}>
            <StyledTitleDividerLineOnly theme={theme} />
            <h1>{message}</h1>
            <StyledTitleDividerLineOnly theme={theme} />
          </StyledWarningAlert>
        </StyleSheetManager>
      );
  }
};
export default Alert;
